import { getElements, ifSelectorExist } from "./utils";

export const accordionFAQ = () => {
  const blocks = document.querySelectorAll(".faq-accordion-block");

  blocks.forEach((block) => {
    const accordions = block.querySelectorAll(".accordion-faq-item");
    const headerHeight = document.querySelector("header")?.offsetHeight || 0;

    const openAccordion = (accordion) => {
      const content = accordion.querySelector(".accordion-faq-item-content");
      accordion.classList.add("active");
      content.style.maxHeight = content.scrollHeight + "px";

      setTimeout(() => {
        const rect = accordion.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const offsetTop = rect.top + scrollTop - headerHeight;

        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }, 500);
    };

    const closeAccordion = (accordion) => {
      const content = accordion.querySelector(".accordion-faq-item-content");
      accordion.classList.remove("active");
      content.style.maxHeight = null;
    };

    accordions.forEach((accordion) => {
      const intro = accordion.querySelector(".accordion-faq-item-header");
      const content = accordion.querySelector(".accordion-faq-item-content");

      intro.onclick = () => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((item) => closeAccordion(item));
          openAccordion(accordion);
        }
      };
    });
  });
};

export const targetFaqItems = () => {
  const faqItems = getElements(".faq-item");

  if (ifSelectorExist(faqItems)) {
    faqItems.forEach(function (item) {
      item.addEventListener("click", function (e) {
        e.preventDefault();

        const targetId = item.getAttribute("data-faq-target");
        const targetElement = document.querySelector(
          `[data-faq-id="${targetId}"]`
        );

        if (ifSelectorExist(targetElement)) {
          const scrollOffset =
            targetElement.getBoundingClientRect().top + window.scrollY - 50;

          window.scrollTo({
            top: scrollOffset,
            behavior: "smooth",
          });
        }
      });
    });
  }
};
